import React from "react";
import "../styles/UXProcessDiagram.css";

const UXProcessDiagram = () => {
  const phases = [
    {
      id: "empathize",
      title: "Empathize & Research",
      color: "#FF6B6B",
      tools: ["Interviews", "Surveys", "Analytics", "Research"],
    },
    {
      id: "define",
      title: "Define & Synthesize",
      color: "#4ECDC4",
      tools: ["Personas", "Journey Maps", "Problem Statements"],
    },
    {
      id: "ideate",
      title: "Ideate & Conceptualize",
      color: "#45B7D1",
      tools: ["Brainstorming", "Sketching", "Prioritization"],
    },
    {
      id: "prototype",
      title: "Prototype & Design",
      color: "#96CEB4",
      tools: ["Wireframes", "UI Design", "Interactions"],
    },
    {
      id: "test",
      title: "Test & Validate",
      color: "#FFEEAD",
      tools: ["Usability Tests", "A/B Testing", "Feedback"],
    },
    {
      id: "implement",
      title: "Implement & Monitor",
      color: "#D4A5A5",
      tools: ["Development", "Analytics", "Optimization"],
    },
  ];

  return (
    <div className="ux-process-diagram">
      <svg viewBox="0 0 800 600" className="process-svg">
        {/* Circular Process Layout */}
        <defs>
          <marker
            id="arrowhead"
            markerWidth="10"
            markerHeight="7"
            refX="9"
            refY="3.5"
            orient="auto"
          >
            <polygon points="0 0, 10 3.5, 0 7" fill="#666" />
          </marker>
        </defs>

        {/* Connecting Lines */}
        <path
          d="M 400,300 m -150,-150 a 212.13,212.13 0 1,1 300,0"
          className="process-path"
          markerEnd="url(#arrowhead)"
          fill="none"
        />

        {/* Phase Circles */}
        {phases.map((phase, index) => {
          const angle = (index * 60 - 90) * (Math.PI / 180);
          const x = 400 + 150 * Math.cos(angle);
          const y = 300 + 150 * Math.sin(angle);

          return (
            <g key={phase.id} transform={`translate(${x},${y})`}>
              <circle r="50" fill={phase.color} className="phase-circle" />
              <text className="phase-title" textAnchor="middle" y="-5">
                {phase.title.split(" & ")[0]}
              </text>
              <text className="phase-title" textAnchor="middle" y="15">
                {phase.title.split(" & ")[1]}
              </text>

              {/* Tools */}
              {phase.tools.map((tool, i) => (
                <text
                  key={tool}
                  className="tool-text"
                  textAnchor="middle"
                  y={45 + i * 12}
                  fontSize="8"
                >
                  {tool}
                </text>
              ))}
            </g>
          );
        })}

        {/* Center Text */}
        <g transform="translate(400,300)">
          <circle r="70" fill="#f8f9fa" className="center-circle" />
          <text textAnchor="middle" className="center-text" y="-10">
            UX Design
          </text>
          <text textAnchor="middle" className="center-text" y="10">
            Process
          </text>
        </g>
      </svg>

      {/* Legend */}
      <div className="process-legend">
        {phases.map((phase) => (
          <div key={phase.id} className="legend-item">
            <span
              className="legend-color"
              style={{ backgroundColor: phase.color }}
            />
            <span className="legend-text">{phase.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UXProcessDiagram;
